module.exports = __webpack_public_path__ + "static/media/jackpots-lvl0.7edf0cbf.png";